import config from '../../../config/environment';
import garageAPI from '../../../services/garage/api';

const ALLOWED_PROPERTIES = new Set([
  'actorType',
  'previousRole',
  'selectedRole',
  'personaId',
  'departmentId',
  'changeType',
  'confirmationReason',
  'confirmationRequired',
  'outcome',
  'failureReason',
  'guardrailReason',
  'changedField',
]);

export const governanceFailureReason = (error) => {
  const status = error?.response?.status;
  if (status === 409) return 'conflict';
  if (status === 422 || status === 400) return 'validation';
  if (status === 401 || status === 403) return 'forbidden';
  if (status >= 500) return 'server';
  if (!error?.response) return 'network';
  return 'unknown';
};

export const governanceGuardrailReason = (error) => {
  const detail = String(error?.response?.data?.detail || '').toLowerCase();
  if (detail.includes('changed after') || detail.includes('refresh')) return 'stale_state';
  if (detail.includes('another full admin')) return 'last_full_admin';
  if (detail.includes('own access')) return 'self_management';
  if (detail.includes('another persona')) return 'cross_persona';
  if (detail.includes('full admins')) return 'full_admin_target';
  if (detail.includes('active persona')) return 'inactive_persona';
  return 'unauthorized';
};

export const emitGovernanceTelemetry = (eventName, properties = {}) => {
  if (!config.ENABLE_ANALYTICS) return;
  const safeProperties = Object.fromEntries(
    Object.entries(properties).filter(
      ([key, value]) => ALLOWED_PROPERTIES.has(key) && value !== undefined
    )
  );
  garageAPI
    .emitGovernanceTelemetry({ eventName, ...safeProperties })
    .catch((error) => {
      // Telemetry must never block or change the governance transaction.
      console.warn('Governance telemetry was not emitted:', error?.message);
    });
};
